import { RemoteGetSearchByCnpj } from 'data/usecases';
import { GetSearchByCnpjUseCaseInterface } from 'domain/usecases/search-by-cnpj/get-search-by-cnpj';
import { makeApiUrlSearchByCnpj } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetSearchCnpj = (): GetSearchByCnpjUseCaseInterface =>
  new RemoteGetSearchByCnpj(makeApiUrlSearchByCnpj(), makeAxiosHttpClient());
